export const token = state => state.token